import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer, closeDrawer } from "@/src/components/dialogs";
import { ReorderableItems } from "@/src/components/reorderable";
import { ReferenceCategory, Reference } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import { useState } from "react";
import { MdOutlineDragIndicator } from "react-icons/md";
import { ReferenceForm } from "./referenceForm";
import { ReferenceChoiceList } from "./referenceChoiceList";

export function ReorderableReferenceChildren({
  label,
  categories,
  current,
  onChange,
}: {
  label?: string;
  current: (Reference | null | undefined)[];
  categories: ReferenceCategory[];
  onChange: (newValue: (Reference | null | undefined)[]) => void;
}) {
  let [references, setReferences] = useState(current);

  return (
    <div className="field">
      <label>{label || "Sous-éléments"}</label>
      <div className="grid c1 gap10">
        <ReorderableItems
          items={references || []}
          listId="permissions"
          listType={"permissions"}
          onReorder={(newItems) => {
            onChange(newItems);
            setReferences(newItems);
          }}
        >
          {references?.map((reference) => {
            if (!reference) return null;

            return (
              <Card
                key={uid()}
                color="blue"
                title={reference.name}
                leading={
                  <div className="grab disabled">
                    <MdOutlineDragIndicator size={15} />
                  </div>
                }
                onEdit={async () => {
                  if (!reference) return;
                  await openDrawer({
                    title: "Modifier une référence",
                    content: (
                      <ReferenceForm
                        current={reference}
                        categories={categories}
                        onChange={(newValue) => {
                          reference = newValue;
                        }}
                      />
                    ),
                    onConfirm: async () => {
                      if (!reference) return;
                      let inserted = await apiFetch("references", "addOne", {
                        reference,
                      });
                      if (!inserted) return;
                      let data = [...references];

                      data.push(inserted);
                      setReferences(data);
                      onChange(data!);
                    },
                  });
                }}
                onDelete={async () => {
                  setReferences([
                    ...references.filter((ref) => ref?.id != reference?.id),
                  ]);
                  onChange([
                    ...references.filter((ref) => ref?.id != reference?.id),
                  ]);
                }}
              ></Card>
            );
          })}
        </ReorderableItems>
        <Button
          type={"tertiary"}
          onClick={async () => {
            let reference: Reference = {
              name: "",
              category: categories?.[0] || "examStep",
              sections: [],
              creator: USER?.get(),
            };

            await openDrawer({
              id: "referenceDialog",
              title: "Choisir une référence",
              content: (
                <ReferenceChoiceList
                  current={references}
                  categories={categories}
                  onSelect={async (newValue) => {
                    closeDrawer("referenceDialog");
                    if (!reference) return;
                    reference = newValue;
                    let inserted = await apiFetch("references", "addOne", {
                      reference,
                    });
                    if (!inserted) return;
                    let data = [...references];

                    data.push(inserted);
                    setReferences(data);
                    onChange(data!);
                  }}
                />
              ),
              footer: <div></div>,
            });
          }}
        >
          Ajouter {label || "un sous-élément"}
        </Button>
      </div>
    </div>
  );
}
